export const assetUrl = path => {
  if (!path) return '';

  const baseUrl = process.env.REACT_APP_URL || '';

  if (/^https?:\/\//i.test(path)) return path;
  if (!baseUrl) return path;

  return `${baseUrl.replace(/\/+$/, '')}/${path.replace(/^\/+/, '')}`;
};
